import React from 'react';
import { Container, Typography, Grid, IconButton } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import { useTheme } from '@mui/material/styles';
import { ContactSection, ContactPaper, ContactInfo, SocialIcons } from '../styles/ContactStyles';
import { useContact } from '../utils/ContactUtils';

const ContactComp = () => {
  const theme = useTheme();
  const { title, email, phone, location, linkedinUrl, githubUrl } = useContact();

  return (
    <ContactSection id="contact">
      <Container maxWidth="lg">
        <Grid container justifyContent="center">
          <Grid item xs={12} md={6}>
            <ContactPaper elevation={3}>
              <Typography variant="h4" gutterBottom sx={{ 
                fontWeight: 'bold', 
                color: theme.palette.mode === 'dark' ? '#BB86FC' : 'primary.main', 
                marginBottom: 3 
              }}>
                {title}
              </Typography>
              <ContactInfo>
                <EmailIcon sx={{ marginRight: 2 }} />
                <Typography color={theme.palette.mode === 'dark' ? '#E0E0E0' : 'inherit'}>{email}</Typography>
              </ContactInfo>
              <ContactInfo>
                <PhoneIcon sx={{ marginRight: 2 }} />
                <Typography color={theme.palette.mode === 'dark' ? '#E0E0E0' : 'inherit'}>{phone}</Typography>
              </ContactInfo>
              <ContactInfo>
                <LocationOnIcon sx={{ marginRight: 2 }} />
                <Typography color={theme.palette.mode === 'dark' ? '#E0E0E0' : 'inherit'}>{location}</Typography>
              </ContactInfo>
              <SocialIcons>
                <IconButton color={theme.palette.mode === 'dark' ? 'secondary' : 'primary'} 
                            href={linkedinUrl} target="_blank">
                  <LinkedInIcon />
                </IconButton>
                <IconButton color={theme.palette.mode === 'dark' ? 'secondary' : 'primary'} 
                            href={githubUrl} target="_blank">
                  <GitHubIcon />
                </IconButton>
              </SocialIcons>
            </ContactPaper>
          </Grid>
        </Grid>
      </Container>
    </ContactSection>
  );
};

export default ContactComp;
